import { createReducer, on } from '@ngrx/store';
import { RunSegment, ScheduledRun, WeeklySchedule, ScheduleUiSettings } from '../models/schedule.model';
import * as WeeklyScheduleActions from '../actions/weekly-schedule.actions';
import * as ScheduledRunActions from '../actions/scheduled-run.actions';
import * as RunSegmentActions from '../actions/run-segment.actions';
import * as ScheduleUiSettingsActions from '../actions/schedule-ui-settings.actions';

export interface ScheduleState {
    weeklySchedules?: WeeklySchedule[];
    selectedWeeklySchedule?: WeeklySchedule;
    scheduleUiSettings?: ScheduleUiSettings;
    scheduleUiSettingsLoading?: boolean;
    scheduleUiSettingsError?: any;
}

export const initialState: ScheduleState = {

};

export const schedulingReducer = createReducer(
    initialState,

    //Weekly Schedule
    on(WeeklyScheduleActions.loadWeeklySchedulesSuccess, (state, { weeklySchedules }) => ({ ...state, weeklySchedules })),
    on(WeeklyScheduleActions.generateNextWeeklyScheduleSuccess, (state, { weeklySchedule }) => ({ ...state, weeklySchedules: [weeklySchedule, ...(state.weeklySchedules ?? [])] })),

    //Selected Weekly Schedule
    on(WeeklyScheduleActions.loadSelectedWeeklyScheduleSuccess, (state, { weeklySchedule }) => ({ ...state, selectedWeeklySchedule: weeklySchedule })),
    on(WeeklyScheduleActions.clearSelectedWeeklySchedule, (state, { }) => ({ ...state, selectedWeeklySchedule: undefined })),
    //Update the returned scheduledRun in the selectedWeeklySchedule
    on(WeeklyScheduleActions.sendRunSegmentsNotificationsSuccess, (state, { runSegments }) => {
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            //create a map with key scheduleId & value the list of segments that got notification sent
            const runSegmentMap: any = {}
            runSegments.forEach((rs: any) => {
                if (!runSegmentMap.hasOwnProperty(rs.scheduledRunId)) {
                    runSegmentMap[rs.scheduledRunId] = []
                }
                runSegmentMap[rs.scheduledRunId].push(rs)
            })
            console.log(runSegmentMap)

            //populate the scheudled run list by replacing all RunSegments that were updated
            const updatedScheduledRuns: ScheduledRun[] = []
            //loop through all scheduled runs and update the ones that had updated RunSegments
            selectedWeeklySchedule.scheduledRuns.forEach(run => {
                const srId = `${run.id}`
                if (Object.keys(runSegmentMap).includes(srId)) {
                    console.log(`processing ${srId}`)
                    if (run.runSegments) {
                        //populate ther run segments by replacing the updated ones from original run segments in state
                        console.log(run.runSegments)
                        const runSegments = run.runSegments.map(rs => {
                            const updatedRunSegments: RunSegment[] = runSegmentMap[srId]
                            const updatedRs = updatedRunSegments.find(updatedRs => updatedRs.id === rs.id)
                            return updatedRs ?? rs;
                        })
                        console.log(runSegments)
                        const updatedSr = { ...run, runSegments: runSegments }
                        console.log(updatedSr)
                        updatedScheduledRuns.push(updatedSr)
                    }
                } else {
                    updatedScheduledRuns.push(run)
                }
                console.log(updatedScheduledRuns)
            })
            const newState = { ...state, selectedWeeklySchedule: { ...selectedWeeklySchedule, scheduledRuns: updatedScheduledRuns } }
            return newState
        }
        return state
    }),


    //Add the returned scheduledRun in the selectedWeeklySchedule
    on(ScheduledRunActions.createScheduledRunSuccess, (state, { scheduledRun }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: [...selectedWeeklySchedule.scheduledRuns, scheduledRun] };
        }
        return newState
    }),

    //Update the returned scheduledRun in the selectedWeeklySchedule
    on(ScheduledRunActions.updateScheduledRunSuccess, (state, { scheduledRun }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            // Replace the updated scheduled run in the array
            const updatedScheduledRuns = selectedWeeklySchedule.scheduledRuns.map(sr => {
                return sr.id === scheduledRun.id ? scheduledRun : sr
            }
            );
            newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: updatedScheduledRuns };
        }
        return newState
    }),

    //Remove the deleted scheduledRun from the selectedWeeklySchedule
    on(ScheduledRunActions.deleteScheduledRunSuccess, (state, { scheduledRunId }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            // Remove the deleted scheduled run from the array
            const updatedScheduledRuns = selectedWeeklySchedule.scheduledRuns.filter(sr => 
                sr.id !== scheduledRunId
            );
            newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: updatedScheduledRuns };
        }
        return newState
    }),

    //Add the returned scheduledRun in the selectedWeeklySchedule
    on(RunSegmentActions.createRunSegmentSuccess, (state, { runSegment }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            // console.log(runSegment)
            //Add new segment
            const scheduledRunToUpdate = selectedWeeklySchedule.scheduledRuns.find(sr => sr.id === runSegment.scheduledRunId)
            if (scheduledRunToUpdate) {
                const updatedScheduledRun: ScheduledRun = { ...scheduledRunToUpdate, runSegments: [...(scheduledRunToUpdate.runSegments ?? []), runSegment] }
                newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: [...selectedWeeklySchedule.scheduledRuns.map(sr => sr.id === runSegment.scheduledRunId ? updatedScheduledRun : sr)] };
            }
        }
        return newState
    }),
    //Update the returned scheduledRun in the selectedWeeklySchedule
    on(RunSegmentActions.updateRunSegmentSuccess, (state, { runSegment }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            //replace updated segment
            const scheduledRunToUpdate = selectedWeeklySchedule.scheduledRuns.find(sr => sr.id === runSegment.scheduledRunId)
            if (scheduledRunToUpdate) {
                const updatedScheduledRun: ScheduledRun = { ...scheduledRunToUpdate, runSegments: [...(scheduledRunToUpdate.runSegments ?? []).map((rs: RunSegment) => rs.id === runSegment.id ? runSegment : rs)] }
                newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: [...selectedWeeklySchedule.scheduledRuns.map(sr => sr.id === runSegment.scheduledRunId ? updatedScheduledRun : sr)] };
            }
        }
        return newState
    }),

    //Update the returned scheduledRun in the selectedWeeklySchedule
    on(RunSegmentActions.updateRunSegmentsSuccess, (state, { scheduledRunId, runSegments }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            //replace updated segment
            const scheduledRunToUpdate = selectedWeeklySchedule.scheduledRuns.find(sr => sr.id === scheduledRunId)
            console.log(`scheduledRunId: ${scheduledRunId}`)
            if (scheduledRunToUpdate) {

                const updatedRunSegments = (scheduledRunToUpdate.runSegments ?? []).map((rs: RunSegment) => {
                    const updatedRS = runSegments.find(s=>s.id === rs.id)
                    return updatedRS ?? rs
                })
                const updatedScheduledRun: ScheduledRun = { ...scheduledRunToUpdate, runSegments: [...updatedRunSegments] }
                newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: [...selectedWeeklySchedule.scheduledRuns.map(sr => sr.id === scheduledRunId ? updatedScheduledRun : sr)] };
            
            }
        }
        return newState
    }),

    //Update the returned scheduledRun in the selectedWeeklySchedule
    on(RunSegmentActions.deleteRunSegmentSuccess, (state, { scheduledRunId, id }) => {
        const newState = { ...state };
        const selectedWeeklySchedule: WeeklySchedule | undefined = state.selectedWeeklySchedule;
        if (selectedWeeklySchedule) {
            //remove deleted segment
            const scheduledRunToUpdate = selectedWeeklySchedule.scheduledRuns.find(sr => sr.id === scheduledRunId)
            if (scheduledRunToUpdate?.runSegments) {
                const updatedScheduledRun: ScheduledRun = { ...scheduledRunToUpdate, runSegments: [...scheduledRunToUpdate.runSegments.filter((rs: RunSegment) => rs.id !== id)] }
                newState.selectedWeeklySchedule = { ...selectedWeeklySchedule, scheduledRuns: [...selectedWeeklySchedule.scheduledRuns.map(sr => sr.id === scheduledRunId ? updatedScheduledRun : sr)] };
            }
        }
        return newState
    }),

    // Schedule UI Settings
    on(ScheduleUiSettingsActions.loadScheduleUiSettings, (state) => ({ 
        ...state, 
        scheduleUiSettingsLoading: true, 
        scheduleUiSettingsError: null 
    })),
    on(ScheduleUiSettingsActions.loadScheduleUiSettingsSuccess, (state, { uiSettings }) => ({ 
        ...state, 
        scheduleUiSettings: uiSettings, 
        scheduleUiSettingsLoading: false, 
        scheduleUiSettingsError: null 
    })),
    on(ScheduleUiSettingsActions.loadScheduleUiSettingsFailure, (state, { error }) => ({ 
        ...state, 
        scheduleUiSettingsLoading: false, 
        scheduleUiSettingsError: error 
    }))

);
